import React from "react";
import withIconComponent from "../../../withIconComponent";

var Globe = function Globe() {
  return /*#__PURE__*/React.createElement("g", {
    className: "nc-icon-wrapper",
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: "2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 1v22M1 12h22",
    stroke: "#FF6400",
    "data-cap": "butt",
    "data-color": "color-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 1a5.5 11 0 1 0 0 22 5.5 11 0 1 0 0-22z",
    stroke: "#FF6400",
    "data-color": "color-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 1a11 11 0 1 0 0 22 11 11 0 1 0 0-22z",
    stroke: "#404040"
  }));
};

export default withIconComponent("NucleoSmallBusinessFinanceGlobe", false)(Globe);